import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useOpidNavigator } from './OpidNavigator';

const OpidLink = ({ path, children = undefined, style = {} }) => {
    const navigation = useOpidNavigator();

    const defaultStyle = {};
    const doNav = ()=>{
        if(path != null){
            navigation.goto(path);
        }
    }
    
    return <TouchableOpacity onPress={()=>doNav()} style={[defaultStyle, style]} activeOpacity={1}>
        <View>{children}</View>
    </TouchableOpacity>;
};

export default OpidLink;